module.exports = __webpack_public_path__ + "img/videographer-1.2c045dc8.jpg";